var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIpfs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 50,
    viewBox: "0 0 99 50",
    width: 99,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.6663 22.438-12.59257-7.1866c.0283-.2237.0283-.4474 0-.6711l12.59257-7.17259c1.0612.769 2.5044.769 3.5656 0l12.5785 7.17259c-.0283.2237-.0283.4474 0 .6711l-12.5785 7.1726c-1.0612-.769-2.5044-.769-3.5656.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.822 42.7115c-.2123.0839-.3962.1958-.5801.3356l-12.59267-7.1866c.14149-1.3003-.58011-2.5307-1.78277-3.048v-14.3591c.21223-.0839.39617-.1958.5801-.3356l12.57844 7.1726c-.1415 1.3003.5801 2.5307 1.7828 3.048v14.3731z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.0319 32.8127c-1.2027.5173-1.9384 1.7617-1.7828 3.048l-12.5784 7.1726c-.184-.1259-.3821-.2377-.5801-.3356l-.0283-14.2613c1.2026-.5173 1.9384-1.7617 1.7827-3.048l12.5926-7.2564c.184.1258.3821.2376.5802.3355v14.3452z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.4492 2.61214 19.6105 11.18536v22.3706l-19.6105 11.1853-19.61056-11.1713v-22.3846zm0-2.097247-.9197.531307-19.610547 11.1853-.91968542.5173v1.0487 22.3706 1.0486l.91968542.5313 19.610547 11.1854.9197.5313.9197-.5313 19.6105-11.1854.9197-.5313v-1.0486-22.3706-1.0487l-.9197-.5313-19.6105-11.18529z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.1222 16.2896h-3.5971v17.4005h3.5971z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.3946 33.6901v-6.3847c.8768.0675 1.776.0675 2.5179.0675 5.1258 0 6.6095-2.5404 6.6095-5.6653 0-3.7994-2.7202-5.418-6.9017-5.418h-5.8227v17.4005zm1.9334-8.8352c-.6744 0-1.6411 0-1.9559-.0224v-5.9126h2.2482c2.1582 0 3.3947 1.0341 3.3947 2.9225v.045c.0224 1.4838-.5171 2.9675-3.687 2.9675z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.8192 16.2896h-10.9259v17.4005h3.597v-7.6661h6.8344v-2.6079h-6.8569v-4.4738h7.1041z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.6614 19.9346.9113-2.3216c-1.3452-.9763-3.1894-1.3234-5.4892-1.3234-3.3629 0-6.1184 1.5621-6.1184 4.7732 0 2.8856 2.1263 4.0138 4.2308 4.7081l2.1263.716c1.4536.499 2.6469.9763 2.6469 2.5385 0 1.4319-1.2367 1.996-3.1243 1.996-1.9092 0-3.9487-.5641-5.1203-1.3018l-.9113 2.5168c1.5188.9764 3.4498 1.4537 6.0316 1.4537 3.6884 0 6.5307-1.6272 6.5307-5.0553 0-3.2111-2.4517-4.2308-4.9251-5.0553l-2.2998-.7593c-.9981-.3255-1.7575-.7811-1.7575-2.0612 0-1.3018 1.0632-1.8225 2.6687-1.8225 1.9527-.0651 3.4714.3038 4.5996.9981z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpfs);
export default __webpack_public_path__ + "static/media/ipfs.9baec0d412c055268756058e70bebfb1.svg";
export { ForwardRef as ReactComponent };